import * as _ from "lodash";

const defaultStickerAvatar = require('./default-profile-avatar.png');

/**
 * @public
 * @param sticker
 * @param {{uid: string}} stickerOwner
 * @returns {boolean}
 */
export function getDisplayedUser(sticker, stickerOwner?) {
  return sticker.from;
}

export function getDisplayedUserAvatarUrl(sticker, stickerOwner?) {
  const displayedUser = getDisplayedUser(sticker, stickerOwner);
  return getUserAvatarUrl(displayedUser);
}

export function getUserAvatarUrl(user) {
  let thumbSource = defaultStickerAvatar;
  let source = defaultStickerAvatar;

  if (user) {
    thumbSource = _.get(user, 'avatar_thumbnail.source') || defaultStickerAvatar;
    source = _.get(user, 'avatar.source') || defaultStickerAvatar;
  }

  return { source, thumbSource };
}

export function getStickerQRFromUrl(qrUrl) {
  const i = qrUrl.lastIndexOf('/');
  return qrUrl.substring(i + 1);
}


// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/services/StickerHelpers.ts